__turbopack_context__.v({
  "Loading": "loading-module__b7X4tG__Loading",
  "LoadingVideo": "loading-module__b7X4tG__LoadingVideo",
});
